export function FullPageLoader({ message }: { message?: string }) {
  return (
    <div className="globalLoaderContainer">
      <div className="globalLoader"></div>
      <p>{message ?? "Loading..."}</p>
    </div>
  );
}
